module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 441
 ** module chunks = 0 1 2 3 10 11 12 17 19 20
 **/